// Scripted knowledge for the site assistant. Kept as plain data so answers can
// be edited without touching component logic — and so a future Phase 2 can
// replace `resolveAnswer` (in index.jsx) with a call to an AI backend while
// leaving this file as the curated fallback. Answer copy is derived from
// containers/services/servicesData.js so the bot and the service pages agree.

// The chips shown first, before the visitor has asked anything.
export const rootMenu = [
  "services",
  "custom",
  "integration",
  "support",
  "pricing"
];

// Every answerable node. `q` is the chip label / echoed user question, `a` is
// the scripted answer, `next` lists follow-up node ids to offer afterwards.
// The special follow-up ids "inquiry" and "partnership" open the lead form
// instead of answering (handled in index.jsx).
export const faqNodes = {
  services: {
    q: "What services do you offer?",
    a: "We work across eight areas: Custom Software Development, Enterprise System Integration, ERP Integration, API Development & Management, AI Automation, Workflow Automation, Production Support & Maintenance, and Cloud & DevOps. Which one would you like to explore?",
    next: ["custom", "integration", "support", "pricing"]
  },
  custom: {
    q: "Do you build custom software?",
    a: "Yes. We design software around your processes instead of forcing you onto off-the-shelf tools — web apps, SaaS products, legacy modernization and cloud-native builds, with secure, scalable architecture and ongoing support. We also bring proven CTRM/ETRM depth for demanding, business-critical domains.",
    next: ["scalable", "security", "integration", "inquiry"]
  },
  integration: {
    q: "Can you connect our systems?",
    a: "Yes. We link enterprise systems, cloud platforms and third-party applications into one reliable, unified flow of data — using APIs, middleware, message queues and event-driven or hybrid-cloud architectures, with real-time sync where you need it.",
    next: ["realtime", "erp", "security", "inquiry"]
  },
  erp: {
    q: "Do you integrate ERP platforms?",
    a: "Yes. We connect your ERP to finance, supply-chain, warehouse, trading and cloud systems so your ERP stays the single source of truth and manual re-keying goes away — through APIs and middleware, with data validation throughout.",
    next: ["realtime", "security", "inquiry"]
  },
  support: {
    q: "Can you support a live system?",
    a: "Yes — Production Support & Maintenance under a clear SLA: application monitoring, incident management, health checks, performance tuning, root-cause analysis and preventive maintenance to keep business-critical systems running without interruption.",
    next: ["sla", "security", "inquiry"]
  },
  scalable: {
    q: "Is what you build scalable?",
    a: "Yes — scalability is designed in from the start, so the system expands with higher volumes, new products or more users without a rebuild.",
    next: ["security", "inquiry"]
  },
  security: {
    q: "How is our data protected?",
    a: "Security is built into design and development: encryption for data at rest and in transit, and role-based access controls so only authorized people can access or change critical information.",
    next: ["inquiry"]
  },
  realtime: {
    q: "Is real-time data exchange possible?",
    a: "Yes — where it's needed, we tailor integrations for real-time data exchange between your systems.",
    next: ["security", "inquiry"]
  },
  sla: {
    q: "How does support and response time work?",
    a: "Support scope and response times are defined in an agreed Service Level Agreement, so you always know what to expect. We also keep systems current with updates, security patches and performance improvements.",
    next: ["support", "inquiry"]
  },
  pricing: {
    q: "How do I get a quote?",
    a: "Pricing tracks scope, so we scope it with you first. The fastest path is to leave your details and a short note — our team will review and reach out.",
    next: ["inquiry", "partnership"]
  }
};

// Nature-of-partnership options offered on the partnership lead form. These map
// the visitor's intent onto the two directions the business cares about:
// collaborating with PSS on delivery, or having PSS support the partner.
export const partnershipTypes = [
  "Collaborate / joint delivery",
  "Subcontract or white-label our services",
  "We want PSS to support/service us",
  "Referral or reseller",
  "Other"
];
